<div class="modal-backdrop" (click)="onCancel()"></div>
<div class="modal">
  <div class="modal-header">
    <h3>{{ 'metrics_days_dialog.title' | translate }}</h3>
  </div>
  <div class="modal-body">
    <label>
      <span>{{ 'metrics_days_dialog.days_label' | translate }}</span>
      <input
        type="number"
        [min]="min"
        [attr.max]="max ?? null"
        step="1"
        [(ngModel)]="daysInput"
        [placeholder]="max !== undefined ? ('metrics_days_dialog.placeholder_min_max' | translate:{min: min, max: max}) : ('metrics_days_dialog.placeholder_min' | translate:{min: min})"
      />
    </label>
    <div *ngIf="showIncludeNotifications">
      <label class="checkbox" style="display: flex; align-items: center; gap: 8px;">
        <input type="checkbox" style="width: 16px; height: 16px;" [(ngModel)]="includeNotifications" />
        <span>{{ 'metrics_days_dialog.include_notifications' | translate }}</span>
      </label>
    </div>
    <div *ngIf="showIncludeViolations">
      <label class="checkbox" style="display: flex; align-items: center; gap: 8px;">
        <input type="checkbox" style="width: 16px; height: 16px;" [(ngModel)]="includeViolations" />
        <span>{{ 'metrics_days_dialog.include_violations' | translate }}</span>
      </label>
    </div>
    <div class="error" *ngIf="error">{{ error }}</div>
  </div>
  <div class="modal-footer">
    <button class="button secondary" type="button" (click)="onCancel()">{{ 'metrics_days_dialog.cancel' | translate }}</button>
    <button class="button" type="button" (click)="onSubmit()">{{ 'metrics_days_dialog.accept' | translate }}</button>
  </div>
</div>


